import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface AccountsState {
  transactionsParams: {
    page: number;
    sort: string;
  };
}

const initialState: AccountsState = {
  transactionsParams: {
    page: 1,
    sort: '-date'
  }
};

const slice = createSlice({
  name: 'accounts',
  initialState,
  reducers: {
    setTransactionsPage: (state, { payload }: PayloadAction<number>) => {
      state.transactionsParams.page = payload;
    },
    increnmentTransactionsPage: (state) => {
      state.transactionsParams.page += 1;
    },
    setTransactionsSort: (state, { payload }: PayloadAction<string>) => {
      state.transactionsParams.sort = payload;
      state.transactionsParams.page = 1;
    }
  }
});

export const {
  setTransactionsPage,
  increnmentTransactionsPage,
  setTransactionsSort
} = slice.actions;

export default slice.reducer;
